export default __webpack_public_path__ + "static/cafe_36054-29c9f38c17c68c2b02b55d79487b4b11.png";